import {FC} from 'react'
import clsx from 'clsx'
import {InputCheck} from '../../InputV2'
type Props = {
  name: string
  disabled?: boolean
  required?: boolean
  labelText?: string
  nameCheck?: any
  readOnly?: boolean
  className?: string
  onchange?: any
}
const InputCheckWrapper: FC<Props> = ({
  name,
  disabled,
  required,
  labelText,
  readOnly,
  nameCheck,
  className,
  onchange,
}) => {
  let classLabel = required ? 'required' : ''
  return (
    <div className={clsx('d-flex flex-column justify-content-center', className)}>
      {labelText && <label className={classLabel}>{labelText}:</label>}
      <div className='d-flex align-items-center'>
        <InputCheck name={name} disabled={disabled} readOnly={readOnly} onchange={onchange} />
        <div>{nameCheck}</div>
      </div>
    </div>
  )
}

export default InputCheckWrapper
